export const highContrast = {
  palette: {
    themePrimary: '#feff00',
    themeLighterAlt: '#0a0a00',
    themeLighter: '#292900',
    themeLight: '#4d4d00',
    themeTertiary: '#999900',
    themeSecondary: '#e0e000',
    themeDarkAlt: '#ffff19',
    themeDark: '#ffff3d',
    themeDarker: '#ffff70',
    neutralLighterAlt: '#000000',
    neutralLighter: '#000000',
    neutralLight: '#000000',
    neutralQuaternaryAlt: '#000000',
    neutralQuaternary: '#000000',
    neutralTertiaryAlt: '#000000',
    neutralTertiary: '#c8c8c8',
    neutralSecondary: '#d0d0d0',
    neutralPrimaryAlt: '#dadada',
    neutralPrimary: '#ffffff',
    neutralDark: '#f4f4f4',
    black: '#f8f8f8',
    white: '#000000',
    blueMid: '#6cb8f6',
    green: '#92c353'

  },
  semanticColors: {
    messageText: '#f4f4f4',
    infoBackground: '#1b1a19',
    infoIcon: '#c8c6c4',
    errorBackground: '#442726',
    errorIcon: '#f1707b',
    blockingBackground: '#442726',
    blockingIcon: '#f1707b',
    severeWarningBackground: '#4f2a0f',
    severeWarningIcon: '#fce100',
    successBackground: '#393d1b',
    successIcon: '#92c353',
    warningBackground: '#433519',
    warningIcon: '#c8c6c4'
  }
};
